import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { environment } from 'src/environments/environment';

if (!environment.production && document.body) {
  document.body.classList.add('test-env');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
